const MuiPickersToolbar = {
    toolbar: {
        backgroundColor: '#034EA2',
    },
}

export default MuiPickersToolbar;